import { IQuoteSummary } from "../interfaces/IQuoteSummery";
import { thanos26GetJson, thanos26PostJson } from "./thanos26Client";

const URL_RECENT = "offerten/zuletzt";

/** A quote the signed in user opened (texts as of opening), stored per user in thanos26 */
export interface IRecentlyOpenedQuote {
    id: string;
    version: string;
    kunde: string | null;
    projekt: string | null;
    offerte: string | null;
    geoeffnet: string;
}

/** The last opened quotes of the signed in user (max. 10), newest first */
async function getRecentlyOpened(): Promise<IRecentlyOpenedQuote[]> {
    return thanos26GetJson(URL_RECENT);
}

/** Remember that the signed in user opened this quote */
async function logOpened(quote: IQuoteSummary): Promise<void> {
    const projekt = [quote.Project?.ProjectNo, quote.Project?.ProjectName].filter(Boolean).join(" ");
    await thanos26PostJson(URL_RECENT, {}, {
        id: String(quote.id),
        version: String(quote.version),
        kunde: quote.Organization?.Name || null,
        projekt: projekt || null,
        offerte: quote.name || null
    });
}

export default { getRecentlyOpened, logOpened };
